import { Card, CardBody, Col } from "reactstrap";
import { Badges, Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BadgesPartButtons } from "../../../../Constants/Constants";
import { BadgeButtonData, BadgeButtonSubTitle } from "../../../../Data/UiKits/Tag&Pills";

const BadgeButton = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BadgesPartButtons} span={BadgeButtonSubTitle} />
        <CardBody>
          <div className="badge-spacing flex-column align-items-start">
            {BadgeButtonData &&
              BadgeButtonData.map((item, index) => (
                <Btn color={item.class} className="d-flex align-items-center" key={index}>
                  {item.text}
                  <Badges color="light" className="rounded-circle btn-p-space text-dark ms-2">
                    {item.iconName}
                  </Badges>
                </Btn>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BadgeButton;
